import React, { Component } from "react";
import Reveal from "./Reveal";
import RegioBanners from "./RegioBanners";
import backgroundVideo from "../images/kfy.mp4";

const NAV_LINKS = [
  { id: "home", label: "Acasă" },
  { id: "about", label: "Despre" },
  { id: "resume", label: "Servicii" },
  { id: "portfolio", label: "Poze Lucrări" },
  { id: "testimonials", label: "Testimoniale" },
  { id: "proiect-regio", label: "Proiect UE" },
];

// Inlocuieste vechiul public/js/init.js (jQuery + waypoints), care rula o singura data dupa
// 380ms si rata elementele randate de React pe conexiuni lente.
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { active: "home", navMode: "top", menuOpen: false };
    this.frame = null;
  }

  componentDidMount() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onScroll);
    this.onScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onScroll);
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  onScroll = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.updateNav();
    });
  };

  updateNav() {
    const y = window.scrollY;
    const header = document.getElementById("home");
    const h = header ? header.offsetHeight : window.innerHeight;

    // Meniul dispare cat timp derulezi prin header (doar pe desktop), apoi revine cu fundal opac
    let navMode = "opaque";
    if (y < h * 0.2) navMode = "top";
    else if (y < h && window.innerWidth > 768) navMode = "hidden";

    // Sectiunea activa = ultima al carei inceput a trecut de 35% din inaltimea ecranului
    let active = "home";
    const line = window.innerHeight * 0.35;
    for (const { id } of NAV_LINKS) {
      const el = document.getElementById(id);
      if (el && el.getBoundingClientRect().top <= line) active = id;
    }

    if (navMode !== this.state.navMode || active !== this.state.active) {
      this.setState({ navMode, active });
    }
  }

  toggleMenu = (e) => {
    e.preventDefault();
    this.setState(prev => ({ menuOpen: !prev.menuOpen }));
  };

  closeMenu = () => {
    if (this.state.menuOpen) this.setState({ menuOpen: false });
  };

  render() {
    if (!this.props.data) return null;

    const { link1, link2, link3, link4, link5, description, image } = this.props.data;
    const profilepic = "images/" + image;

    return (
      <>
        <RegioBanners />

        {/* Main Website Header */}
        <header id="home" className="viewport-header">
          <video id="background-video" autoPlay loop muted playsInline preload="metadata">
            <source src={backgroundVideo} type="video/mp4" />
          </video>

          <nav
            id="nav-wrap"
            className={[
              this.state.menuOpen ? "open" : "",
              this.state.navMode === "opaque" ? "opaque" : "",
              this.state.navMode === "hidden" ? "nav-hidden" : "",
            ].join(" ").trim() || undefined}
          >
            <a
              className="mobile-btn"
              href="#nav"
              title={this.state.menuOpen ? "Ascunde meniul" : "Arată meniul"}
              aria-expanded={this.state.menuOpen}
              aria-controls="nav"
              onClick={this.toggleMenu}
            >
              {this.state.menuOpen ? "Ascunde meniul" : "Arată meniul"}
            </a>

            <ul id="nav" className="nav">
              {NAV_LINKS.map(({ id, label }) => (
                <li key={id} className={this.state.active === id ? "current" : undefined}>
                  <a href={"#" + id} onClick={this.closeMenu}>{label}</a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="row banner">
            <div className="banner-text">
              <h1 className="visually-hidden">
                KFY Auto — Service Auto, ITP, Vopsitorie, Daune RCA, Constatări, Reparații Post-Accident, Vulcanizare și Detailing în Caracal, Olt
              </h1>
              <Reveal direction="up" delay={100}>
                <picture>
                  <source srcSet="images/logo.webp" type="image/webp" />                                                                                                   
                  <img className="profile-pic-header" src={profilepic} alt="KFY Auto — Service Auto Caracal" />
                </picture>
              </Reveal>
              <Reveal direction="up" delay={300} duration={1000}>
                <h3>{description}</h3>
              </Reveal>
              <hr />
              <Reveal direction="up" delay={500} duration={1200}>
                <ul className="social">
                  <a href={link1} className="button btn github-btn" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-whatsapp"></i>WhatsApp - 0762 626 185
                  </a>
                  <a href={link2} className="button btn github-btn" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-whatsapp"></i>WhatsApp - 0760 703 031
                  </a>
                  <a href={link3} className="button btn github-btn" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-tiktok"></i>TikTok
                  </a>
                  <a href={link4} className="button btn github-btn" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-facebook"></i>Facebook
                  </a>
                  <a href={link5} className="button btn github-btn" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-instagram"></i>Instagram
                  </a>
                </ul>
              </Reveal>
            </div>
          </div>

          <p className="scrolldown">
            <a href="#about">
              <i className="icon-down-circle"></i>
            </a>
          </p>
        </header>
      </>
    );
  }
}

export default Header;
